export default __webpack_public_path__ + "static/media/HowItWorks_Bg_Line.ddf4ac82.png";